export type AppVersion = { version: string; commit: string };
export function parseVersion(value: unknown): AppVersion | null {
  if (!value || typeof value !== 'object') return null;
  const { version, commit } = value as Partial<AppVersion>;
  return typeof version === 'string' && version.trim() && typeof commit === 'string' && commit.trim()
    ? { version, commit } : null;
}
export const versionKey = (value: AppVersion) => JSON.stringify([value.version, value.commit]);

// Storage is an adapter concern: this logic also works when storage is unavailable.
export function createVersionTracker(runningVersion: string, previous: string[] = []) {
  const attempted = new Set(previous);
  let baseline: AppVersion | undefined;
  let remote: AppVersion | undefined;
  const key = () => remote ? versionKey(remote) : 'sw:' + runningVersion;
  const changed = () => !!remote && (remote.version !== runningVersion || remote.commit !== baseline?.commit);
  const allowed = () => remote ? !attempted.has(key()) : attempted.size === 0;
  return {
    observe(value: AppVersion) {
      baseline ??= value;
      remote = value;
      return changed() && allowed();
    },
    shouldGate(waiting: boolean) { return (waiting || changed()) && allowed(); },
    markAttempt() { attempted.add(key()); },
    attempts() { return [...attempted]; }
  };
}
